var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gameDtailllsss section dataAll-content" },
    [
      _c("div", { staticClass: "flex-cont dataSummary-header" }, [
        _c(
          "div",
          { staticClass: "flex-star" },
          [
            _c(
              "el-select",
              {
                ref: "",
                attrs: {
                  clearable: "",
                  filterable: "",
                  placeholder: "请选择游戏"
                },
                on: { change: _vm.gamechange },
                model: {
                  value: _vm.searchData.game,
                  callback: function($$v) {
                    _vm.$set(_vm.searchData, "game", $$v)
                  },
                  expression: "searchData.game"
                }
              },
              _vm._l(_vm.gameData, function(item, index) {
                return _c(
                  "el-option",
                  {
                    key: index,
                    attrs: { "value-key": item, label: item, value: item }
                  },
                  [_vm._v(_vm._s(item) + " ")]
                )
              }),
              1
            ),
            _c(
              "el-button",
              {
                staticStyle: { "margin-left": "100px" },
                attrs: { type: "success" },
                on: { click: _vm.searchClick }
              },
              [_vm._v("搜索")]
            )
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticClass: "levelDetails-body" },
        [
          _c(
            "div",
            { staticClass: "button_box" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "success" },
                  on: {
                    click: function($event) {
                      return _vm.handleSource("t", 1)
                    }
                  }
                },
                [_vm._v("新增")]
              )
            ],
            1
          ),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%", "margin-left": "30px" },
              attrs: { data: _vm.tableData, border: "" }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", width: "80" }
              }),
              _c("el-table-column", {
                attrs: { prop: "timestamp", label: "日期", width: "180" }
              }),
              _c("el-table-column", { attrs: { prop: "game", label: "游戏" } }),
              _c("el-table-column", {
                attrs: { prop: "details", label: "详情" }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  width: "160",
                  align: "center",
                  fixed: "right"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("div", { staticClass: "x-c" }, [
                          _c(
                            "div",
                            {
                              staticClass: "controlsBtn",
                              on: {
                                click: function($event) {
                                  return _vm.handleSource(scope.row.id)
                                }
                              }
                            },
                            [_vm._v("修改")]
                          ),
                          _c("div", { staticClass: "controlsBtn-vertical" }),
                          _c(
                            "div",
                            {
                              staticClass: "controlsBtn",
                              on: {
                                click: function($event) {
                                  return _vm.handleDelete(scope.row.id)
                                }
                              }
                            },
                            [_vm._v("删除")]
                          )
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          layout: "total, prev, pager, next",
          "current-page": _vm.searchData.page,
          total: _vm.total,
          "page-size": _vm.pagrSize
        },
        on: { "current-change": _vm.handleCurrentChange }
      }),
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showing,
            expression: "showing"
          }
        ],
        staticClass: "mask"
      }),
      _c(
        "div",
        { staticStyle: { "pointer-events": "none" } },
        [
          _vm.addWayConfig
            ? _c("addGamedetail", {
                ref: "addWayConfig",
                attrs: { showing: _vm.showing },
                on: {
                  refreshDataList: _vm.searchClick,
                  changeShow: _vm.changeShow
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }